<script>
	import Helper from '../../Models/Helper';
	import Trigger from '../../Models/Trigger';

	let show = false;
	let visible = false;
	let alert = {message: 'Melding', icon: 'alert'};
	let show_timeout;
	let visible_timeout;

	function open() {
		clearTimeout(show_timeout);
		clearTimeout(visible_timeout);

		if (!show) {
			show = true;
			visible = false;
			visible_timeout = setTimeout(() => { visible = true }, 1000 * .25);
		}

		show_timeout = setTimeout(close, alert.message.length * 75);
	}

	function close() {
		clearTimeout(show_timeout);
		clearTimeout(visible_timeout);

		visible = false;
		show = true;
		show_timeout = setTimeout(() => { show = false }, 1000 * 1);
	}

	Trigger.subscribe('alert', state => {
		alert = state;
		open();
	});

	setTimeout(() => { visible = true }, 1000 * .5);
</script>

<div class="alert" class:show="{show}" class:visible="{visible}">
	<div class="alert-container">
		<div class="alert-text">
			<i class="fad fa-{alert.icon}"></i> {alert.message}
		</div>
	</div>
</div>